export default __webpack_public_path__ + "static/media/ventures-banner.0226b6a5.png";